export default "__VITE_ASSET__DN3Hz3wA__"